<template>
	<div>
    <div v-show="show">
      <div id="mask1" class="mask1"></div>
      <div class="dialog1" id="dialog1" ref="dialog">
          <div class="dialog1_head move_part1" id="move_part1">
              <span></span>      
              <i class="closebtn" id="close closebtn" title="关闭" @click="close"></i>
          </div>
          <div class="dialog1_content">
          <div id="ext1" class="ext1">
              <slot>
              使用slot占位
              </slot>
          </div>
          </div>
      </div>
    </div>
        
	</div>

</template>

<script>
export default {
  name: "umDialog",
  data: function() {
    return {
    };
  },
  created() {},
  mounted() {
    var that=this
    that.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕 
           //声明需要用到的变量
      var mx = 0, my = 0;      //鼠标x、y轴坐标（相对于left，top）
      var dx = 0, dy = 0;      //对话框坐标（同上）
      var isDraging = false;      //不可拖动
      var dialogW,dialogH,dialog;
      //鼠标按下
      $(".move_part1").mousedown(function (e) {
          e = e || window.event;
          mx = e.clientX;     //点击时鼠标X坐标
          my = e.clientY;     //点击时鼠标Y坐标
          if(e.target.tagName=='DIV'){
            dialog=e.target.parentElement
          }else{
            dialog=e.target.parentElement.parentElement
          }
          dialogW=dialog.offsetLeft
          dialogH=dialog.offsetTop
          dx = dialogW-document.documentElement.scrollLeft;
          dy = dialogH-document.documentElement.scrollTop;
          isDraging = true;      //标记对话框可拖动
      });

      //鼠标移动更新窗口位置
      $(document).mousemove(function (e) {
          var e = e || window.event;
          var x1 = e.clientX;      //移动时鼠标X坐标
          var y1 = e.clientY;      //移动时鼠标Y坐标
          if (isDraging) {        //判断对话框能否拖动

              var moveX = dx + x1 - mx;      //移动后对话框新的left值
              var moveY = dy + y1 - my;      //移动后对话框新的top值
              //设置拖动范围
              var pageW = $(window).width();
              var pageH = $(window).height();
              var dialog1W = dialog.offsetWidth;
              var dialog1H = dialog.offsetHeight;
              var maxX = pageW - dialog1W;       //X轴可拖动最大值
              var maxY = pageH - dialog1H;       //Y轴可拖动最大值
              moveX = Math.min(Math.max(0, moveX), maxX);     //X轴可拖动范围
              moveY = Math.min(Math.max(0, moveY), maxY);     //Y轴可拖动范围
              // 重新设置对话框的left、top
              dialog.style.left=moveX + 'px'
              dialog.style.top=moveY + 'px'
          };
      });

      //鼠标离开
      $(".move_part1").mouseup(function () {
          isDraging = false;
      });
      var open = {
        openiframe1(ummsg) {
          if(ummsg.data.width&&ummsg.data.height){
            $('.dialog1_content .popup-content').css({ "width": ummsg.data.width, "height": ummsg.data.height });
          }else{
            $('.dialog1_content .popup-content').css({ "width": '800px', "height": '550px' });
          }
          $('.dialog1_head span').text(ummsg.data.title)
          if(that.show){
            that.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕 
                that.autoCenter(that.$refs.dialog)
            });
          }
        },
      }
      $UMCore.on(["iframe"], open);
    });
  },
  // watch:{
  //   show(val){
  //     this.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕 
  //         this.autoCenter(this.$refs.dialog)
  //     });
  //   }
  // },
  props:['show'],
  methods: {
    autoCenter(el){
      this.$nextTick(() => { //使用nextTick为了保证dom元素都已经渲染完毕 
        var bodyW = $(window).width();
        var bodyH = $(window).height();
        var elW = el.offsetWidth;
        var elH = el.offsetHeight;
        el.style.left=(bodyW - elW) / 2 + 'px'
        el.style.top=(bodyH - elH) / 2 + 'px'
      });
     
    },
    close(){
      this.$emit('showchange',false)
    }
  }
};
</script>

<style>
.mask1 {
  width: 100vw;
  height: 100vh;
  background: #000;
  position: fixed;
  top: 0px;
  left: 0px;
  opacity: 0.4;
  z-index: 1000;
  /* display: none; */
}

.dialog1 {
  height: auto;
  background: #fff;
  position: fixed;
  z-index: 1001;
  /* display: none; */
  border-radius: 3px;
  overflow: hidden;
}

.dialog1_head {
  width: 100%;
  height: 30px;
  background: var(--theme-color);
  opacity: 0.85;
  padding: 0 10px;
  line-height: 30px;
  color: #fff;
  cursor: move;
  position: relative;
}
.dialog1_head span{
    margin-left: 10px;
}
.dialog1_content {
  width: 100%;
  /* height: 500px; */
  /* padding: 1px; */
}
.dialog1_content iframe,
.dialog1_content #ext1 {
  width: 100%;
  height: 100%;
  overflow: auto;
}
#ext1::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: hsla(0, 0%, 60%, 0.5);
  width: 8px;
}
#ext1::-webkit-scrollbar {
  width: 8px;
  height: 1px;
  display: block;
}
.dialog1_head .closebtn{
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
  width: 11px;
  height: 11px;
  background-image: url('/img/icongroup.png') ;
  background-position: 0 22px;
  background-size: cover;
}
#maximize {
  right: 60px;
  background-position: 0 -16px;
}
#minimize {
  right: 90px;
  background-position: 0 16px;
}
.home-contanier {
  position: relative;
}
.popup-footer{
    /* background: #F7F7F7; */
    height: 45px;
    /* line-height: 45px; */
    text-align: center;
    padding: 0 20px;
}
.popup-footer button{
    width: 70px;
    height: 30px;
    text-align: center;
    color: #fff;
    background: #2E9CF1;
    border: 0;
    border-radius:2px;
}
.popup-footer button.confirm{
    border:1px solid var(--theme-color);
    background:var(--theme-color);
}
.popup-footer button.cancel{
    border:1px solid rgba(217, 217, 217, 1);
    color: #666666;
    background: #fff;
    margin-left: 20px;
}
.popup-content{
    padding: 20px;
    overflow: auto;
}
.popup-content::-webkit-scrollbar-thumb {
  border-radius: 5px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: hsla(0, 0%, 60%, 0.5);
}
.popup-content::-webkit-scrollbar {
  width: 8px;
  height: 1px;
  display: block;
}
</style>




// WEBPACK FOOTER //
// src/packages/dialog/um-dialog.vue